import { GridCol, mixins, styled, TagLabel } from '@bob/library'
import { Asset } from '@websrc/App/Components/Asset/Asset'
import { Link } from 'gatsby'

export const GridColWrapper = styled(GridCol)`
  ${mixins.margin.bottom(20)}
  @media print {
    break-inside: avoid;
    display: inline-block;
  }
`

export const Wrapper = styled(Link)`
  width: 100%;
  ${mixins.padding(0, 0, 50, 0)}
  display: flex;
  flex-direction: column;
  @media print {
    flex-direction: row-reverse;
    align-items: center;
  }
  position: relative;
  height: 100%;
  background: ${({ theme }) => theme.background.primary};
`

export const DetailsWrapper = styled.div`
  padding: 10px 15px 15px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`

export const Title = styled.h2`
  ${mixins.typography.headlineSmall}
  ${mixins.margin.bottom(5)}
`

export const Product = styled.div`
  ${mixins.typography.subtitleMedium}
`

export const Description = styled.div`
  ${mixins.typography.paragraphMedium}
  ${mixins.margin.top(15)}
  ${mixins.margin.bottom(30)}
`

export const ImageContainer = styled.figure`
  position: relative;
  margin: 0;
  min-height: 40px;
`

export const ImageCaption = styled.figcaption`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.5);
  color: ${({ theme }) => theme.color.primary};
  ${mixins.typography.subtitleMedium}
  padding: 10px 15px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  @media print {
    display: none;
  }
`

export const LessonTags = styled.div`
  padding-top: 42px;
  margin-top: auto;
  ${mixins.typography.subtitleMedium}
`

export const StyledAsset = styled(Asset)`
  text-align: center;
`

export const InfoWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 1rem;
`

export const InfoItem = styled.div`
  color: ${({ theme }) => theme.color.grayDark};
  ${mixins.typography.paragraphMedium}
  &:not(:last-child) {
    ${mixins.margin.right(20)}
  }
`

export const HybridLabel = styled(TagLabel)`
  position: absolute;
  top: 5px;
  right: 10px;
  z-index: 1;

  html[dir='rtl'] & {
    right: calc(100% - 10px);
    transform: translateX(100%);
  }
`
